import { call } from 'redux-saga/effects';
import { userAccountCreationStep } from '../userAccountCreationStep';

export function* professionalSignupFlow(flow = 'mentors', options) {
  yield call(userAccountCreationStep, flow, options);
  return true;
}
